const statesJSON = document.querySelector('#map-states')?.textContent?.trim();
const tooltipElement = document.getElementById('tooltip');

if (statesJSON && tooltipElement) {
	const statesData = JSON.parse(statesJSON);

	let isLocked = false;
	let lockedBy = null;

	const showTooltip = (html, x, y) => {
		if (isLocked) return;
		tooltipElement.innerHTML = html;
		tooltipElement.style.display = 'block';
		tooltipElement.style.left = x + 20 + 'px';
		tooltipElement.style.top = y - 10 + 'px';
		tooltipElement.classList.remove('is-locked');
		tooltipElement.style.pointerEvents = 'none'; // hover mode: ignore mouse
	};

	const moveTooltip = (x, y) => {
		if (isLocked) return;
		tooltipElement.style.left = x + 20 + 'px';
		tooltipElement.style.top = y - 10 + 'px';
	};

	const hideTooltip = () => {
		if (isLocked) return;
		tooltipElement.style.display = 'none';
		tooltipElement.innerHTML = '';
	};

	const lockTooltip = (html, x, y, state) => {
		isLocked = true;
		lockedBy = state;

		// Add close button + content
		tooltipElement.innerHTML = `
			<button class="tooltip-close" type="button" aria-label="Close tooltip">&times;</button>
			<div class="tooltip-body">${html}</div>
		`;
		tooltipElement.style.display = 'block';
		tooltipElement.style.left = x + 20 + 'px';
		tooltipElement.style.top = y - 10 + 'px';
		tooltipElement.classList.add('is-locked');
		tooltipElement.style.pointerEvents = 'auto'; // locked: allow clicks

		const btn = tooltipElement.querySelector('.tooltip-close');
		if (btn) {
			btn.addEventListener('click', (ev) => {
				ev.stopPropagation();
				unlockTooltip();
			}, { once: true });
			// optional: focus for a11y
			try { btn.focus({ preventScroll: true }); } catch {}
		}
	};

	const unlockTooltip = () => {
		isLocked = false;
		lockedBy = null;
		tooltipElement.classList.remove('is-locked');
		tooltipElement.style.pointerEvents = 'none';
		tooltipElement.style.display = 'none';
		tooltipElement.innerHTML = '';
	};

	// Close on Escape
	document.addEventListener('keydown', (ev) => {
		if (isLocked && ev.key === 'Escape') unlockTooltip();
	});

	// Don't accidentally close when clicking inside tooltip
	tooltipElement.addEventListener('click', (e) => e.stopPropagation());

	Object.entries(statesData).forEach(([key, value]) => {
		const state = value.state;
		const tooltip = value.tooltip || '';

		const stateElement = document.querySelector(`.state[data-state="${state}"]`);
		const stateElement2 = document.querySelector(`.state[data-state="${state}2"]`);
		const textElement  = document.querySelector(`.state-text[data-state="${state}"]`);

		if (stateElement) stateElement.classList.add('has-content');
		if (stateElement2) stateElement2.classList.add('has-content');
		if (textElement)  textElement.classList.add('has-content');

		// --- helpers to wire events on both state and its label ---
		const wire = (el, peerSelector) => {
			if (!el) return;

			el.addEventListener('mouseover', (e) => {
				el.classList.add('hover');
				const peer = peerSelector ? document.querySelector(peerSelector) : null;
				if (peer) peer.classList.add('hover');

				if (tooltip) showTooltip(tooltip, e.pageX, e.pageY);
			});

			el.addEventListener('mousemove', (e) => moveTooltip(e.pageX, e.pageY));

			el.addEventListener('mouseout', () => {
				el.classList.remove('hover');
				const peer = peerSelector ? document.querySelector(peerSelector) : null;
				if (peer) peer.classList.remove('hover');

				hideTooltip();
			});

			el.addEventListener('click', (e) => {
				if (!tooltip) return;
				// lock at click position
				lockTooltip(tooltip, e.pageX, e.pageY, state);
			});
		};

		wire(stateElement, `.state-text[data-state="${state}"]`);
		wire(stateElement2, `.state-text[data-state="${state}2"]`);
		wire(textElement,  `.state[data-state="${state}"]`);

		// on stateElement hover, add .hover to stateElement2. On mouseout, remove it.
		if (stateElement && stateElement2) {
			stateElement.addEventListener('mouseover', () => stateElement2.classList.add('hover'));
			stateElement.addEventListener('mouseout', () => stateElement2.classList.remove('hover'));

			// do the same for text and stateElement2
			if (textElement) {
				textElement.addEventListener('mouseover', () => stateElement2.classList.add('hover'));
				textElement.addEventListener('mouseout', () => stateElement2.classList.remove('hover'));
			}

			// and vice versa
			stateElement2.addEventListener('mouseover', () => stateElement.classList.add('hover'));
			stateElement2.addEventListener('mouseout', () => stateElement.classList.remove('hover'));

			if (textElement) {
				textElement.addEventListener('mouseover', () => stateElement.classList.add('hover'));
				textElement.addEventListener('mouseout', () => stateElement.classList.remove('hover'));
			}
		}
	});
}
